import { DATE_FORMAT, DATE_TIME_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { dayjs } from "@/utils/dayjs";

type TDateInput = string | Date | null | undefined;

/**
 * Format a date value with the given pattern.
 * Note: dayjs(undefined) resolves to "now" and is valid, so the falsy check must come first.
 */
const formatWithFallback = (value: TDateInput, pattern: string, fallback: string): string => {
  if (!value) return fallback;
  const date = dayjs(value);
  return date.isValid() ? date.format(pattern) : fallback;
};

/**
 * Format an ISO timestamp as "YYYY/MM/DD HH:mm" (最終ログイン日時 etc.).
 * Falls back to the empty datetime placeholder when the value is missing or unparsable.
 */
export const formatDateTime = (value?: TDateInput): string => formatWithFallback(value, DATE_TIME_FORMAT, EMPTY_STR.DATE_TIME);

/**
 * Format an ISO timestamp as "YYYY/MM/DD" (登録日, 契約開始日 etc.).
 * Falls back to the empty date placeholder when the value is missing or unparsable.
 */
export const formatDate = (value?: TDateInput): string => formatWithFallback(value, DATE_FORMAT, EMPTY_STR.DATE);
